import HammLogoA from "./HammLogoA";

const HYGIENE_ITEMS = ["TAMPON- & BINDENSPENDER", "ABFALLBEHÄLTER", "SEIFENSPENDER", "SENSORSPENDER", "HANDTUCHSPENDER", "TOILETTENPAPIERSPENDER"];
const FERTIGUNG_ITEMS = ["ENTWICKLUNG", "LASERSCHNEIDEN", "ABKANTEN", "SCHWEISSEN", "SCHLEIFEN", "PULVERBESCHICHTUNG"];

function Row({ items, ariaHidden }) {
  return (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {[...items, ...items].map((item, i) => (
        <span key={item + i + (ariaHidden ? "-b" : "-a")} className="flex items-center">
          <span className="px-8 font-[Chivo] font-bold uppercase tracking-tight text-2xl sm:text-3xl text-[var(--ci-grey)]/80 whitespace-nowrap">{item}</span>
          <HammLogoA data-testid="bullet-logo-a" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative border-y border-[#E3E8EC] bg-white overflow-hidden" data-testid="editorial-marquee">
      <div className="py-6 overflow-hidden" data-testid="marquee-band-hygiene">
        <div className="flex w-max animate-marquee">
          <Row items={HYGIENE_ITEMS} ariaHidden={false} />
          <Row items={HYGIENE_ITEMS} ariaHidden={true} />
        </div>
      </div>
      <div className="py-6 overflow-hidden border-t border-[#E3E8EC]" data-testid="marquee-band-lohnfertigung">
        <div className="flex w-max animate-marquee-reverse">
          <Row items={FERTIGUNG_ITEMS} ariaHidden={false} />
          <Row items={FERTIGUNG_ITEMS} ariaHidden={true} />
        </div>
      </div>
    </div>
  );
}
